import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import React, {ChangeEvent} from "react";
import {IScheduleSettings} from "../../../../Interfaces/Schedule.interfaces";
import {ClassNameMap} from "notistack";
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import { setItineraryListVisibility } from "Containers/Schedule/scheduleRoutines";
import {useDispatch, useSelector} from "react-redux";
import {selectScheduleItineraryListVisibility} from "../../../../Containers/Schedule/scheduleSelectors";

interface Props {
    schedule: IScheduleSettings["schedule"],
    listConfig: IScheduleSettings["schedule"]["listConfig"],
    toggleHidePastEvents: Function,
    globalClasses: ClassNameMap
}
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    formLabel:{
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    }
}));


const ItineraryVisibility = ({globalClasses, schedule, listConfig, toggleHidePastEvents} : Props) =>{
    const classes = useStyles();
    const dispatch = useDispatch()

    const handleChange = (event:ChangeEvent<any>) => {
        const value = event.target.value;
        dispatch(setItineraryListVisibility(value))
    };
    const itineraryVisiblity = useSelector(selectScheduleItineraryListVisibility)

    return (
        <Card>
            <CardHeader classes={{ root: globalClasses.cardHeader }} title="Visibility" />
            <CardContent>
                <FormControl component="fieldset">
                    <FormLabel className={classes.formLabel} component="legend">Which lists should be visible?</FormLabel>
                    <RadioGroup aria-label="What should be visible?" name="listVisibility" value={itineraryVisiblity} onChange={handleChange}>
                        <FormControlLabel value="both" control={<Radio />} label="All Itinerary and My Itinerary " />
                        <FormControlLabel value="all" control={<Radio />} label="All Itinerary only" />
                        <FormControlLabel value="my" control={<Radio />} label="My Itinerary only" />
                    </RadioGroup>
                </FormControl>
            </CardContent>
        </Card>
    )
}

export default ItineraryVisibility;